import EquipoProfilePage from "./EquipoProfilePage/EquipoProfilePage";

export default function OpenEquipo() {
  return <EquipoProfilePage publicView />;
}
